import { Component, computed } from '@angular/core';
import { Store } from '@ngrx/store';

import { Language } from '../../models/language.model';
import { LanguageService } from '../../services/language-service';
import { selectCurrentLang } from '../../store/selectors/language.selectors';

@Component({
  selector: 'app-language-switcher',
  standalone: false,
  templateUrl: './language-switcher.component.html',
  styleUrl: './language-switcher.component.scss',
})
export class LanguageSwitcherComponent {
  readonly languages = [
    {
      code: 'ar',
      label: 'العربية',
      flag: 'flags/sy.svg',
    },
    {
      code: 'en',
      label: 'English',
      flag: 'flags/gb.svg',
    },
  ] as Language[];

  readonly selectedLang = this.store.selectSignal(selectCurrentLang);

  readonly selectedLanguage = computed(
    () =>
      this.languages.find((language) => language.code === this.selectedLang()) ?? this.languages[0]
  );

  constructor(
    private readonly store: Store,
    private readonly languageService: LanguageService
  ) {}

  async switchLanguage(language: string): Promise<void> {
    if (language !== 'ar' && language !== 'en') {
      return;
    }

    await this.languageService.changeLanguage(language);
  }
}
